import React from "react";
import {
  Box,
  Grid,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Typography,
} from "@mui/material";

const formatEquipmentType = (type) => {
  if (!type) return "";
  const formatted = type.toLowerCase().replace(/_/g, " ");
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

const EquipmentTable = ({ title, equipments }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography
        variant="h6"
        sx={{
          backgroundColor: "#1976d2",
          color: "#fff",
          p: 1,
          borderRadius: 1,
        }}
      >
        {title}
      </Typography>
      <TableContainer component={Paper} sx={{ mt: 1 }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: "#eeeeee" }}>
              <TableCell
                sx={{ textAlign: "left", fontWeight: "bold", py: 0.5, px: 2 }}
              >
                Name
              </TableCell>
              <TableCell
                sx={{ textAlign: "left", fontWeight: "bold", py: 0.5, px: 2 }}
              >
                Description
              </TableCell>
              <TableCell
                sx={{ textAlign: "left", fontWeight: "bold", py: 0.5, px: 2 }}
              >
                Type
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {equipments.map((eq) => (
              <TableRow
                key={eq.id}
                sx={{
                  backgroundColor: "#ffffff",
                  "&:hover": { backgroundColor: "#e0e0e0" },
                  height: 40,
                }}
              >
                <TableCell sx={{ textAlign: "left", py: 0.5, px: 2 }}>
                  {eq.name}
                </TableCell>
                <TableCell sx={{ textAlign: "left", py: 0.5, px: 2 }}>
                  {eq.description}
                </TableCell>
                <TableCell sx={{ textAlign: "left", py: 0.5, px: 2 }}>
                  {formatEquipmentType(eq.equipmentType)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

const EquipmentListingPage = ({ equipments }) => {
  // Filter equipments by type.
  const filterByType = (type) =>
    equipments.filter((eq) => eq.equipmentType === type);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 4 }}>
        Equipments
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <EquipmentTable title="Cardio" equipments={filterByType("CARDIO")} />
        </Grid>
        <Grid item xs={12} md={6}>
          <EquipmentTable
            title="Non‑Machine"
            equipments={filterByType("NON_MACHINE")}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <EquipmentTable
            title="General Machine"
            equipments={filterByType("GENERAL_MACHINE")}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <EquipmentTable
            title="Upper Body Machine"
            equipments={filterByType("UPPER_BODY_MACHINE")}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <EquipmentTable
            title="Core and Glutes Machine"
            equipments={filterByType("CORE_AND_GLUTES_MACHINE")}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <EquipmentTable
            title="Lower Body Machine"
            equipments={filterByType("LOWER_BODY_MACHINE")}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default EquipmentListingPage;
